<template>
  <div>
    <collection @sorting="sorting" @itemDelete="itemDelete" :loading="loading" :data="items" :structure="collectionData" :has_searched="has_searched" :params="params" model="plan"></collection>
    <pagination @goToPage="goToPage" :page="page" :total-pages="total_pages"></pagination>
  </div>
</template>
<script>
import Api from '@/api/Plan'
import Ui from '@/classes/Ui'
import Collection from '@/components/helpers/DataDisplay/Collection'
import {collectionMixin} from '@/components/mixins/Collection'

let structure = [
  { name: 'id', credentials: 'admin', sortable: true, credentials: 'root' },
  { name: 'name', type: 'project_name', title: 'Name', sortable: true },
  { name: 'price', title: 'Price', sortable: true },
  { name: 'organizations_count', title: 'Organizations', sortable: true }
]

let default_sort_by = "id"
let default_sort_order = "DESC"
let default_filters = {}

export default {
  mixins: [collectionMixin],
  components: {
    Collection
  },
  data(){
    return {
      model: "plans",
      api: new Api(),
      collectionData: structure,
      query: { },
      title: "ui.pages.plans",
      loading: false,
      collectionMixinConfig: {
        storeResetPage: 'RESET_CURRENT_PAGE_PLANS',
        routerName: 'plans',
        emptyState: 'plans',
        default_filters: default_filters,
        default_sort_by: default_sort_by,
        default_sort_order: default_sort_order
      }
    }
  },
  created() {
    this.initQuery()
  },
  mounted(){
    Ui.clearHeaderButtons()
  }
}
</script>



// WEBPACK FOOTER //
// Plans.vue?a48231ba